<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<table mat-table [dataSource]="scoreDtos() ?? []">
  <ng-container matColumnDef="position">
    <th mat-header-cell *matHeaderCellDef>No.</th>
    <td mat-cell *matCellDef="let element">{{ asScoreDto(element).position }}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let element">
      <div
        class="name-container"
        [matTooltip]="teamIsCurrentlyPlaying(element) ? 'Team is currently playing' : null"
      >
        <span
          class="name-text"
          [ngClass]="{
            'grey-text': !asScoreDto(element).ready,
          }"
        >
          {{ asScoreDto(element).name }}&nbsp;&nbsp;&nbsp;
          @if (!viewOnly() && !asScoreDto(element).ready) {
            <button
              class="check-in-button"
              mat-icon-button
              aria-label="mark team as ready"
              (click)="checkInTeam.emit(element)"
              [matTooltip]="'Mark team as ready'"
            >
              <mat-icon class="material-icons-outlined">waving_hand</mat-icon>
            </button>
          }
          @if (teamIsCurrentlyPlaying(element)) {
            <mat-icon class="material-icons-outlined currently-playing-icon">play_circle</mat-icon>
          }
        </span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="wins">
    <th mat-header-cell *matHeaderCellDef>Wins</th>
    <td mat-cell *matCellDef="let element">
      <strong>{{ asScoreDto(element).wins }}</strong>
    </td>
  </ng-container>

  <ng-container matColumnDef="losses">
    <th mat-header-cell *matHeaderCellDef>Losses</th>
    <td mat-cell *matCellDef="let element">{{ asScoreDto(element).losses }}</td>
  </ng-container>

  <ng-container matColumnDef="points">
    <th mat-header-cell *matHeaderCellDef>Points</th>
    <td mat-cell *matCellDef="let element">
      <strong>{{ asScoreDto(element).points }}</strong>
    </td>
  </ng-container>

  <ng-container matColumnDef="gamesPlayed">
    <th mat-header-cell *matHeaderCellDef>Games Played</th>
    <td mat-cell *matCellDef="let element">{{ asScoreDto(element).gamesPlayed }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr class="mat-mdc-row" *matNoDataRow>
    <td class="mat-mdc-cell" [colSpan]="displayedColumns.length">
      <div>There are no teams registered in the tournament yet.</div>
    </td>
  </tr>
</table>
